var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-content",staticStyle:{"padding":"70px 10px 10px"}},[_c('div',{staticClass:"study-menu"},[_c('study-menu')],1),_c('router-view',{staticClass:"study-content",attrs:{"name":"studyContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }